<template>
    <div id="list" ref="list" class="list" :style="{
        height: height
    }">
        <slot name="default"></slot>

        <div class="mt-1rem display-flex-center" v-show="!pagination.firstLoading && pagination.isLoading">
            <van-loading />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ListLazyload',
    data() {
        return {
            loading: false,
            finished: false
        }
    },
    props: {
        height: String,
        pagination: Object
    },
    mounted() {
        // this.init()
        window.addEventListener('scroll', this.checkIfBottom);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.checkIfBottom);
    },
    methods: {
        checkIfBottom() {
            const list = this.$refs.list;
            if(!list) {
                return;
            }
            const rect = list.getBoundingClientRect();
            const isBottom = rect.bottom <= window.innerHeight;

            if (isBottom) {
                this.onLoad();
            }
        },
        // init() {
        //     const container = document.getElementById('list');
        //     // console.log(container)
        //     container.addEventListener('scroll', () => {
        //     const isBottom = container.scrollTop + container.clientHeight >= container.scrollHeight;

        //     if (isBottom) {
        //         this.onLoad()
        //     }
        //     });
        // },
        onLoad() {
            if(!this.pagination.lastPage) {
                this.$emit('onLoad')
            }
        }
    }
}
</script>

<style scoped>
.list {
    /* overflow-y: auto; */
}
</style>